import { __decorate, __param } from 'tslib';
import { InjectionToken, ElementRef, Inject, Input, Directive, NgModule } from '@angular/core';
import { typedFromEvent, TuiDestroyService, TuiHoveredService, tuiDefaultProp, tuiRequiredSetter } from '@taiga-ui/cdk';
import { TUI_ABSTRACT_HINT_DEFAULT_OPTIONS, AbstractTuiHint } from '@taiga-ui/core/abstract';
import { TuiHintService } from '@taiga-ui/core/services';
import { of } from 'rxjs';
import { filter, startWith, distinctUntilChanged, switchMap, delay, takeUntil } from 'rxjs/operators';

/** Default values for pointer hint options */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@taiga-ui/core/services';
import * as ɵngcc2 from '@taiga-ui/cdk';
const TUI_POINTER_HINT_DEFAULT_OPTIONS = Object.assign(Object.assign({}, TUI_ABSTRACT_HINT_DEFAULT_OPTIONS), { tuiHintShowDelay: 0, tuiHintHideDelay: 0 });
const TUI_POINTER_HINT_OPTIONS = new InjectionToken('Default parameters for pointer hint directive', {
    factory: () => TUI_POINTER_HINT_DEFAULT_OPTIONS,
});
const tuiPointerHintOptionsProvider = (options) => ({
    provide: TUI_POINTER_HINT_OPTIONS,
    useValue: Object.assign(Object.assign({}, TUI_POINTER_HINT_DEFAULT_OPTIONS), options),
});

let TuiPointerHintDirective = class TuiPointerHintDirective extends AbstractTuiHint {
    constructor(elementRef, hintService, destroy$, hoveredService, options) {
        super(elementRef, hintService, null, options);
        this.destroy$ = destroy$;
        this.options = options;
        this.currentMouseRect = this.mousePositionToClientRect();
        this.tuiHintShowDelay = this.options.tuiHintShowDelay;
        this.tuiHintHideDelay = this.options.tuiHintHideDelay;
        this.content = '';
        const hint$ = hoveredService.createHovered$(this.elementRef.nativeElement).pipe(filter(() => !!this.content), startWith(false), distinctUntilChanged());
        hint$
            .pipe(switchMap(visible => of(visible).pipe(delay(visible ? this.tuiHintShowDelay : this.tuiHintHideDelay))), takeUntil(destroy$))
            .subscribe({
            next: visible => {
                if (visible) {
                    this.showTooltip();
                }
                else {
                    this.hideTooltip();
                }
            },
            complete: () => {
                this.hideTooltip();
            },
        });
        this.initMouseMoveSubscription();
    }
    // TODO: Remove null in 3.0
    set tuiPointerHint(value) {
        if (!value) {
            this.hideTooltip();
            this.content = '';
            return;
        }
        this.content = value;
    }
    getElementClientRect() {
        return this.currentMouseRect;
    }
    initMouseMoveSubscription() {
        const mouseMove$ = typedFromEvent(this.elementRef.nativeElement, 'mousemove');
        mouseMove$.pipe(takeUntil(this.destroy$)).subscribe(({ clientX, clientY }) => {
            this.currentMouseRect = this.mousePositionToClientRect(clientX, clientY);
        });
    }
    mousePositionToClientRect(x = 0, y = 0) {
        return {
            left: x,
            right: x,
            top: y,
            bottom: y,
            width: 0,
            height: 0,
        };
    }
};
TuiPointerHintDirective.ɵfac = function TuiPointerHintDirective_Factory(t) { return new (t || TuiPointerHintDirective)(ɵngcc0.ɵɵdirectiveInject(ElementRef), ɵngcc0.ɵɵdirectiveInject(TuiHintService), ɵngcc0.ɵɵdirectiveInject(TuiDestroyService), ɵngcc0.ɵɵdirectiveInject(TuiHoveredService), ɵngcc0.ɵɵdirectiveInject(TUI_POINTER_HINT_OPTIONS)); };
TuiPointerHintDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: TuiPointerHintDirective, selectors: [["", "tuiPointerHint", "", 5, "ng-container"]], inputs: { tuiHintShowDelay: "tuiHintShowDelay", tuiHintHideDelay: "tuiHintHideDelay", tuiPointerHint: "tuiPointerHint" }, features: [ɵngcc0.ɵɵProvidersFeature([TuiDestroyService]), ɵngcc0.ɵɵInheritDefinitionFeature] });
TuiPointerHintDirective.ctorParameters = () => [
    { type: ElementRef, decorators: [{ type: Inject, args: [ElementRef,] }] },
    { type: TuiHintService, decorators: [{ type: Inject, args: [TuiHintService,] }] },
    { type: TuiDestroyService, decorators: [{ type: Inject, args: [TuiDestroyService,] }] },
    { type: TuiHoveredService, decorators: [{ type: Inject, args: [TuiHoveredService,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [TUI_POINTER_HINT_OPTIONS,] }] }
];
__decorate([
    Input(),
    tuiDefaultProp()
], TuiPointerHintDirective.prototype, "tuiHintShowDelay", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiPointerHintDirective.prototype, "tuiHintHideDelay", void 0);
__decorate([
    Input(),
    tuiRequiredSetter()
], TuiPointerHintDirective.prototype, "tuiPointerHint", null);
TuiPointerHintDirective = __decorate([ __param(0, Inject(ElementRef)),
    __param(1, Inject(TuiHintService)),
    __param(2, Inject(TuiDestroyService)),
    __param(3, Inject(TuiHoveredService)),
    __param(4, Inject(TUI_POINTER_HINT_OPTIONS))
], TuiPointerHintDirective);

let TuiPointerHintModule = class TuiPointerHintModule {
};
TuiPointerHintModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: TuiPointerHintModule });
TuiPointerHintModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function TuiPointerHintModule_Factory(t) { return new (t || TuiPointerHintModule)(); } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiPointerHintDirective, [{
        type: Directive,
        args: [{
                selector: '[tuiPointerHint]:not(ng-container)',
                providers: [TuiDestroyService]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef, decorators: [{
                type: Inject,
                args: [ElementRef]
            }] }, { type: ɵngcc1.TuiHintService, decorators: [{
                type: Inject,
                args: [TuiHintService]
            }] }, { type: ɵngcc2.TuiDestroyService, decorators: [{
                type: Inject,
                args: [TuiDestroyService]
            }] }, { type: ɵngcc2.TuiHoveredService, decorators: [{
                type: Inject,
                args: [TuiHoveredService]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [TUI_POINTER_HINT_OPTIONS]
            }] }]; }, { tuiHintShowDelay: [{
            type: Input
        }], tuiHintHideDelay: [{
            type: Input
        }], tuiPointerHint: [{
            type: Input
        }] }); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TuiPointerHintModule, { declarations: [TuiPointerHintDirective], exports: [TuiPointerHintDirective] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiPointerHintModule, [{
        type: NgModule,
        args: [{
                declarations: [TuiPointerHintDirective],
                exports: [TuiPointerHintDirective]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { TUI_POINTER_HINT_DEFAULT_OPTIONS, TUI_POINTER_HINT_OPTIONS, TuiPointerHintDirective, TuiPointerHintModule, tuiPointerHintOptionsProvider };

//# sourceMappingURL=taiga-ui-core-directives-pointer-hint.js.map